import React from 'react';
import { Translate, useTranslate } from 'core/translate';
import { useAppContext } from '../AppContext';
import HeaderTitle from '../HeaderTitle';

const FilterControls = props => {
  const translate = useTranslate();
  const { years, brands, types, country } = useAppContext();
  const { selectedYear, onYearChange, onBrandChange, onTypeChange } = props;

  const yearOptions = years.map((year, index) => (
    <option key={index}>{year}</option>
  ));

  let showTypeFilter = '';
  if (country === 'US') {
    showTypeFilter = (
      <div className="filter-controls__dropdowns">
        <label
          className="filter-controls__dropdowns-label"
          htmlFor="styles-select">
          <Translate value="model.selector.styles.label" />:{' '}
        </label>
        <select
          id="styles-select"
          className="brand-dropdown"
          onChange={event => {
            onTypeChange(event.target.value);
          }}>
          <option value="">{translate('model.selector.brand.all')}</option>
          {types.map(type => (
            <option key={type} value={type}>
              {translate(`model.selector.styles.${type}`)}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className="filter-controls">
      <div className="filter-controls__title show-for-medium">
        <HeaderTitle />
      </div>
      <div className="filter-controls__dropdowns">
        <label
          className="filter-controls__dropdowns-label"
          htmlFor="model-year-select">
          <Translate value="model.selector.year.label" />:{' '}
        </label>
        <select
          id="model-year-select"
          className="model-year-dropdown"
          defaultValue={selectedYear}
          onChange={event => {
            onYearChange(parseInt(event.target.value));
          }}>
          {yearOptions}
        </select>
      </div>
      <div className="filter-controls__dropdowns">
        <label
          className="filter-controls__dropdowns-label"
          htmlFor="brand-select">
          <Translate value="model.selector.brand.label" />:{' '}
        </label>
        <select
          id="brand-select"
          className="brand-dropdown"
          onChange={event => {
            onBrandChange(event.target.value);
          }}>
          <option value="">{translate('model.selector.brand.all')}</option>
          {brands.map(brand => (
            <option key={brand} value={brand}>
              {translate(brand)}
            </option>
          ))}
        </select>
      </div>
      {showTypeFilter}
    </div>
  );
};

export default FilterControls;
